import MultiLinkedArtistList from "components/Picker/ArtistPicker/MultiLinkedArtistList";
import { ModalForMultiPicker } from "components/Picker/ModalForMultiPicker";
import React from "react";
import { LinkedArtistsPanel } from "./LinkedArtistsPanel";
import { LinkedArtistToUserPanelMessage } from "./LinkedPanelMessage";

interface Props {
  userToClientId: number;
  environment: server.dto.Environments;
}

export const LinkedArtistUserPanel = (props: Props) => {
  const [isNewModalOpen, setIsNewModalOpen] = React.useState(false);
  const [queryKeyIncrement, setQueryKeyIncrement] = React.useState(0);

  const onAddArtists = async (newArtists: server.dto.ArtistSmall[]) => {
    await window.CoreApi.UserToClient.LinkArtists({
      userToClientId: props.userToClientId,
      artistIds: newArtists.map(a => a.artistId),
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
    setIsNewModalOpen(false);
  }

  const setAccessToAllArtists = async () => {
    await window.CoreApi.UserForInternalAdmin.SetAccessAllArtists({
      userToClientId: props.userToClientId,
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  const unlinkArtist = async (artist: server.dto.ArtistForList) => {
    await window.CoreApi.UserToClient.UnlinkArtists({
      userToClientId: props.userToClientId,
      artistIds: [artist.artistId],
    });
    setQueryKeyIncrement(queryKeyIncrement + 1);
  }

  return <>
    <LinkedArtistsPanel<server.dto.PaginatedLinkedArtistToUserToClientInstruction>
      queryKey={queryKeyIncrement.toString()}
      perPage={8}
      title={RESX.SoUser.AccessToArtistData}
      renderLinkedArtistPanelMessage={(selected, total) => <LinkedArtistToUserPanelMessage
        selected={selected}
        total={total}
        environment={props.environment}
        onAllowAccessToAllArtists={setAccessToAllArtists}
      />}
      listFunc={window.CoreApi.UserToClient.PaginatedAssociatedArtistsSmall}
      initialInstruction={{
        userToClientId: props.userToClientId,
        whereInOrNotIn: "in",
        keyword: "",
        page: 1,
        perPage: 8,
      }}
      onDelete={unlinkArtist}
      onAdd={() => setIsNewModalOpen(true)}
    />

    {isNewModalOpen && <ModalForMultiPicker
      buttonLabel={RESX.Buttons.btnSelect}
      modalTitle={site.currentEnvironment.functionGroups.artist.plural}
      modalSize="small"
      onClose={() => setIsNewModalOpen(false)}
      onSave={onAddArtists}
      initialValue={[]}
      renderModalContent={(editedValue, setEditedValue) => <MultiLinkedArtistList
        initialInstruction={{
          userToClientId: props.userToClientId,
          whereInOrNotIn: "notIn",
          keyword: "",
          page: 1,
          perPage: 20,
        }}
        listFunc={window.CoreApi.UserToClient.PaginatedAssociatedArtistsSmall}
        onChange={setEditedValue}
        value={editedValue}
      />}
    />}
  </>
}